import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default () => {
    const faqs = gsap.utils.toArray('.faq__items');

    if (!faqs) {
        return
    }

    faqs.forEach((faq: HTMLElement) => {
        const items = faq.querySelectorAll<HTMLElement>('.faq__item')

        if (!items) {
            return
        }

        gsap.set(items, {
            y: 45, autoAlpha: 0
        });

        gsap.to(items, {
            y: 0,
            autoAlpha: 1,
            stagger: 0.1,
            ease: "power2.out",
            scrollTrigger: {
                trigger: faq,
                start: 'top 80%',
                toggleActions: "play pause resume pause",
            }
        });
    });
};